/**
 * 防抖 在事件被触发一定事件后再执行回调，如果在这段事件内又被触发，则重新计时
 * 使用场景：
 * 1、搜索框中，用户在不断输入值时，用防抖来节约请求资源
 * 2、window触发resize的时候，不断的调整浏览器窗口大小会不断的触发这个事件，用防抖来让其只触发一次
 * @param fn 回调
 * @param delay 时间间隔的阈值(单位：ms) 默认500ms
 */
export function debounce(fn: Function, delay = 500) {
  let timer: number;
  // eslint-disable-next-line func-names
  return function (this: void, ...args: any) {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      fn.apply(this, args);
    }, delay);
  };
}

/**
 * 节流 规定在一段时间内，只能触发一次函数。如果这段时间内触发多次函数，只有一次生效
 * 使用场景：
 * 1、鼠标不断点击触发，mousedown(单位时间内只触发一次)
 * 2、监听滚动事件，比如是否滑到底部自动加载更多
 * @param fn 回调
 * @param delay 时间间隔的阈值(单位：ms) 默认500ms
 * @this throttle
 */
export function throttle(fn: Function, delay = 500) {
  // last为上一次触发回调的时间, timer是定时器
  let last = 0;
  let timer: any = null;
  // 将throttle处理结果当作函数返回
  // eslint-disable-next-line func-names
  return function (this: void) {
    // 保留调用时的this上下文
    const context = this;
    // 保留调用时传入的参数
    // eslint-disable-next-line prefer-rest-params
    const args = arguments;
    // 记录本次触发回调的时间
    const now = +new Date();

    // 判断上次触发的时间和本次触发的时间差是否小于时间间隔的阈值
    if (now - last < delay) {
      // 如果时间间隔小于我们设定的时间间隔阈值，则为本次触发操作设立一个新的定时器
      clearTimeout(timer);
      timer = setTimeout(() => {
        last = now;
        fn.apply(context, args);
      }, delay);
    } else {
      // 如果时间间隔超出了我们设定的时间间隔阈值，那就不等了，无论如何要反馈给用户一次响应
      last = now;
      fn.apply(context, args);
    }
  };
}

/**
 * 判断是移动端还是 pc 端 ，true 表示是移动端，false 表示是 pc 端
 */
export function isMobileOrPc() {
  return /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent);
}

/**
 * 判断
 * @param a 新对象
 * @param b 原对象
 */
export function isObjectValueEqualNew(a:any, b:any): boolean {
  if (!a || !b) {
    return a == b;
  }
  let aProps = Object.keys(a);
  let bProps = Object.keys(b);

  if (aProps.length != bProps.length) {
    return false;
  }
  for (let i = 0; i < aProps.length; i++) {
    let propName = aProps[i]
    let propA = a[propName]
    let propB = b[propName]
    if ((typeof propA === 'object')) {
      let status = isObjectValueEqualNew(propA, propB);
      if (!status) {
        return false;
      }
    } else if (propA !== propB) {
      return false
    }
  }
  return true
}
